import { useCallback, useEffect, useMemo, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { AutoComplete, Space } from "antd";
import { getValueFromNestedObject } from "@/Utils/Index";

const SearchableSelect = (props) => {
  const {
    options,
    form: { values, setFieldValue, setFieldTouched },
    field: { name, label, placeholder },
  } = props;

  const value = getValueFromNestedObject(values, name);

  const deselectedOptions = useMemo(() => [...options], [options]);
  const [selectedOptions, setSelectedOptions] = useState(() => {
    const selectedValue = deselectedOptions.filter((option) => option.value === value);
    return selectedValue || [];
  });
  const [inputValue, setInputValue] = useState(value || "");
  const [availableOptions, setAvailableOptions] = useState(deselectedOptions);

  useEffect(() => {
    if (selectedOptions.length > 0) {
      setFieldValue(name, selectedOptions[0].value || "");
      setInputValue(selectedOptions[0].label);
    }
  }, [selectedOptions, name, setFieldValue]);

  const handleSearch = useCallback(
    (searchValue) => {
      setInputValue(searchValue);
      if (searchValue === "") {
        setAvailableOptions(deselectedOptions);
        return;
      }
      RegExp.escape = function (s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      };

      const escapedValue = RegExp.escape(searchValue);
      const filterRegex = new RegExp(escapedValue, "i");
      const resultOptions = deselectedOptions.filter((option) => option.label.match(filterRegex));
      setAvailableOptions(resultOptions);
    },
    [deselectedOptions]
  );

  const handleSelect = useCallback(
    (selectedValue, option) => {
      setInputValue(option.label);
      setFieldValue(name, selectedValue);
      setSelectedOptions([option]);
    },
    [name, setFieldValue]
  );

  const handleChange = useCallback(
    (value) => {
      setInputValue(value);
      setFieldValue(name, value || "");
    },
    [name, setFieldValue]
  );

  return (
    <div style={{ height: "auto" }}>
      <Space direction="vertical" size="small" style={{ width: "100%" }}>
        <AutoComplete
          value={inputValue}
          options={availableOptions.map((option) => ({
            value: option.value,
            label: option.label,
          }))}
          onSearch={handleSearch}
          onSelect={handleSelect}
          onChange={handleChange}
          placeholder={placeholder || "Search"}
          allowClear
          suffixIcon={<SearchOutlined />}
          onBlur={() => {
            setFieldTouched(name, true);
          }}
          style={{ width: "100%" }}
        />
      </Space>
    </div>
  );
};

export default SearchableSelect;
